import { registerNewDrawingOverlays } from "./new-overlays";

export { registerNewDrawingOverlays };

/** Registers overlays introduced after the initial chart-drawings migration. */
export function registerAdditionalDrawingOverlays() {
  registerNewDrawingOverlays();
}
